import { css } from 'linaria';

export const advantagesSection = css`
  display: grid;
  grid-column-gap: 20px;
  grid-template-columns: repeat(4, 280px);
  width: 100%;
  margin-bottom: 80px;

  @media (--only-desktop) {
    grid-gap: 48px 32px;
    grid-template-columns: repeat(2, 454px);
    grid-template-rows: repeat(2, 122px);
  }

  @media (--only-tablet) {
    grid-gap: 32px 24px;
    grid-template-columns: repeat(2, 316px);
    grid-template-rows: repeat(2, 120px);
    margin-bottom: 64px;
  }

  @media (--only-mobile) {
    grid-row-gap: 32px;
    grid-template-columns: 100%;
    margin-bottom: 48px;
  }
`;

export const advantageContainer = css`
  display: flex;
  flex-direction: column;

  @media (--to-desktop) {
    flex-direction: row;
  }
`;

export const advantageImage = css`
  width: 97px;
  height: 97px;

  @media (--only-largeDesktop) {
    margin-bottom: 10px;
  }

  @media (--only-desktop) {
    margin-right: 16px;
  }

  @media (--only-tablet) {
    width: 69px;
    height: 69px;
    margin-right: 12px;
  }

  @media (--only-mobile) {
    width: 50px;
    height: 50px;
    margin-right: 16px;
  }
`;

export const advantageName = css`
  width: 100%;

  @media (--to-desktop) {
    width: auto;
    margin-bottom: 8px;
  }

  @media (--to-desktop) {
    font-size: 16px;
    line-height: 22px;
  }

  @media (--only-mobile) {
    margin-bottom: 2px;
  }
`;

export const advantageDescription = css`
  @media (--to-desktop) {
    font-size: 14px;
    line-height: 18px;
  }
`;
